import { render, staticRenderFns } from "./bind-modify-phone.vue?vue&type=template&id=558f8229&scoped=true"
import script from "./bind-modify-phone.vue?vue&type=script&lang=js"
export * from "./bind-modify-phone.vue?vue&type=script&lang=js"
import style0 from "./bind-modify-phone.vue?vue&type=style&index=0&id=558f8229&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558f8229",
  null
  
)

export default component.exports